module.exports = __webpack_public_path__ + "img/pocket-tablet_jp.6927c6a.jpg";